import createChannelsInitialValues from './createChannelsInitialValues';

export default createChannelsInitialValues;
